// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__mj2da","dragIcon":"Choice_dragIcon__1xTC3","left":"Choice_left__10WUH","input":"Choice_input__h0xBG"};